import { Component } from '@angular/core';
import { RetailersService } from '../retailers.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IRetailerDto } from 'src/app/models/backend';
import { take } from 'rxjs';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-retailer-credits',
  templateUrl: './retailer-credits.component.html',
  styleUrls: ['./retailer-credits.component.scss']
})
export class RetailerCreditsComponent {
  
  errors: string[] | null = null;
  eventForm: FormGroup
  
  constructor(public retailerService: RetailersService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
  private toastr:ToastrService
) {

  }
  ngOnInit() {
    this.retailerService.GetRetailerById(this.retailerService.id)
      .pipe(take(1))
      .subscribe({
        next: r => {
          console.log(r)
          this.SetValuetoForm(r)
        },
        error: e => this.errors = e.error?.errors || [e.error?.message]
      })
  }
  SetValuetoForm(retailer: IRetailerDto) {
    // this.retailerService.id = null
    this.eventForm = this.fb.group({
      firstName:retailer.firstName,
      lastName: retailer.lastName,
      fullName: retailer.fullName,
      email: retailer.email,
      address: retailer.address,
      phoneNo: retailer.phoneNo,
      city: retailer.city,
      countryId:retailer.countryId,
      zipCode: retailer.zipCode,
      retailerType: retailer.retailerType,
      retailerPlanType: retailer.retailerPlanType,
      discountTemplateId:retailer.discountTemplateId,
      dailyLimit:retailer.dailyLimit,
      creditLimit:retailer.creditLimit,
      code:retailer.code,
      isTestMode:retailer.isTestMode,
      userName:retailer.userName
    });
    console.log(this.eventForm)
  }

  onSubmit() {
    console.log(this.eventForm.value)
    var mobUser = this.eventForm.value.isMobileUser;
    var testAccount = this.eventForm.value.isTestAccount;
    const discountId = parseInt(this.eventForm.value.discountTemplateId, 10);

    const countryId = parseInt(this.eventForm.value.countryId, 10);
    const retailerTypeNumber = parseInt(this.eventForm.value.retailerType, 10);
    const retailerPlanTypeNumber = parseInt(this.eventForm.value.retailerPlanType, 10);
    const dailyLimitNumber = parseInt(this.eventForm.value.dailyLimit, 10);
    const creditLimitNumber = parseInt(this.eventForm.value.creditLimit, 10);
    if (!this.eventForm.valid) return this.eventForm.markAllAsTouched();

    this.eventForm = this.fb.group({
      id:this.retailerService.id,
      firstName: this.eventForm.value.firstName,
      lastName: this.eventForm.value.lastName,
      email: this.eventForm.value.email,
      code: this.eventForm.value.code,
      fullName: this.eventForm.value.fullName,
      address: this.eventForm.value.address,
      phoneNo: this.eventForm.value.phoneNo,
      city: this.eventForm.value.city,
      countryId:countryId,
      zipCode: this.eventForm.value.zipCode,
      retailerType: retailerTypeNumber,
      retailerPlanType:retailerPlanTypeNumber,
      discountTemplateId:discountId,
      isActive:true,
      dailyLimit:dailyLimitNumber,
      creditLimit:creditLimitNumber,
      isTestMode: this.eventForm.value.isTestMode,
      username:this.eventForm.value.userName
    })
    console.log(this.eventForm.value)
    this.retailerService.UpdateRetailer(this.eventForm.value)
      .subscribe({
        next: r => {
          // Swal.fire('Updated', '', 'success')
          this.toastr.success('Updated','Success')
          this.activeModal.close({ refresh: true });
        },
        // error: e => this.errors = e.error?.errors || [e.error?.message]
        error:e=>{
          if(e.error?.errors || [e.error?.message])
          {
            this.toastr.error('Oops!', e.error.message);
          }
          else{
            this.toastr.error('Oops!', "Something went wrong");
  
          }
        }
      })
  }
}
